var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiVideo = function SvgAiVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M8.73 7.02 15 12l-6.27 4.98zM19.98.75a2.5 2.5 0 0 1 2.52 2.52v17.46a2.5 2.5 0 0 1-2.52 2.52H2.52A2.5 2.5 0 0 1 0 20.73V3.27A2.5 2.5 0 0 1 2.52.75zm0 19.98V3.27H2.52v17.46z"
  })));
};
export default SvgAiVideo;